import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import type { EditorInfo } from 'modules/surveys/pages/Show/hooks'

interface Props {
  editor: EditorInfo
}

export default function EmployeeLabelSupervisor({ editor }: Props) {
  const fullName = getFullDisplayName({ firstName: editor.firstName, lastName: editor.lastName })

  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      <UserAvatar size="s40" user={{ avatar: editor.avatar, fullName }} />
      <Box>
        <Text.Normal weight="medium">{fullName}</Text.Normal>
      </Box>
    </Box>
  )
}
